// import React, { useState } from "react";
// import RestaurantImages from "./components/RestaurantImages";
// import CuisinesAndTiming from "./components/CuisinesAndTiming";
// import { createRestaurantApi } from "./Api";
// import { Link } from "react-router-dom";
// import Stepper from "./components/Stepper";

// const CreateRestro = () => {
//   const [stepNumber, setStepNumber] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [formSubmitted, setFormSubmitted] = useState(false);
//   const [restaurantId, setRestaurantId] = useState(null);
//   const [cuisineArray, setCuisineArray] = useState([]);
//   const [thumbnailImage, setThumbnailImage] = useState("");
//   const [imagesArray, setImagesArray] = useState([]);
//   const [timingArray, setTimingArray] = useState([
//     { day: "Monday", timeslots: ["1PM-2PM", "2PM-3PM", "3PM-4PM"] },
//     { day: "Tuesday", timeslots: ["1PM-2PM", "2PM-3PM", "3PM-4PM"] },
//     { day: "Wednesday", timeslots: ["1PM-2PM", "2PM-3PM", "3PM-4PM"] },
//     { day: "Thursday", timeslots: ["1PM-2PM", "2PM-3PM", "3PM-4PM"] },
//     { day: "Friday", timeslots: ["1PM-2PM", "2PM-3PM", "3PM-4PM"] },
//     { day: "Saturday", timeslots: ["1PM-2PM", "2PM-3PM", "3PM-4PM"] },
//     { day: "Sunday", timeslots: ["1PM-2PM", "2PM-3PM", "3PM-4PM"] },
//   ]);

//   const [formData, setFormData] = useState({
//     restaurant_name: "",
//     cuisines: [],
//     opening_timings: [],
//     current_rating: 0,
//     thumbnail: "",
//     email: "",
//     password: "",
//     accountManager: "",
//     ownerName: "",
//     isHalalCertified: false,
//     halalCertificate: "",
//     restaurant_images: [],
//     address: "",
//     latitude: 1.3521,
//     longitude: 103.8198,
//     restaurantType: "",
//     phone: "",
//     menuList: [],
//     restaurant_floors: "",
//     priceRange: 0,
//   });

//   const [isHalalCertified, setIsHalalCertified] = useState(false);

//   //make a function to increase or decrease step number based on input type but it cannot be less than 1 and greater than 4

//   const handleStep = (e) => {
//     if (e.target.name === "next") {
//       if (stepNumber < 4) {
//         setStepNumber(stepNumber + 1);
//       }
//     } else if (e.target.name === "prev") {
//       if (stepNumber > 1) {
//         setStepNumber(stepNumber - 1);
//       }
//     }
//   };

//   const handleSubmit = async (e) => {
//     setLoading(true);
//     setLoading(false);

//     let data = {
//       ...formData,
//       restaurant_images: imagesArray,
//       cuisines: cuisineArray,
//       thumbnail: thumbnailImage,
//       opening_timings: timingArray,
//     };
//     const res = await createRestaurantApi(data);

//     if (res.isError) {
//       console.log(res);
//       alert("Error ", res.data);
//     } else {
//       setFormSubmitted(true);
//     }

//     //set the restaurant id from result
//   };

//   return (
//     <div className="min-h-screen bg-gray-100  p-4 px-10 w-full">
//       <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
//         Create Restaurant
//       </h2>

//       <div className="w-8/12 mx-auto">
//         <Stepper stepNumber={stepNumber} setStepNumber={setStepNumber} />
//       </div>

//       <div className="w-9/12 mx-auto">
//         {stepNumber == 1 && (
//           <div className="p-5   my-4">
//             <div className="mt-8 p-4">
//               <div>
//                 <div className="flex flex-col md:flex-row">
//                   <div className="w-full mx-2 flex-1 svelte-1l8159u">
//                     <div className="font-bold h-6 mt-3 ml-3 text-xs leading-8 uppercase">
//                       {" "}
//                       Restaurant Name
//                     </div>
//                     <div className="block text-gray-700 text-sm font-bold mb-2 mr-5">
//                       <input
//                         onChange={(e) =>
//                           setFormData({
//                             ...formData,
//                             restaurant_name: e.target.value,
//                           })
//                         }
//                         placeholder="Just a hint.."
//                         className="mt-3 mr-70 mt-3 mr-70 shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                       />{" "}
//                     </div>
//                   </div>
//                   <div className="w-full mx-2 flex-1 svelte-1l8159u">
//                     <div className="font-bold h-6 mt-3 ml-3 text-xs leading-8 uppercase">
//                       {" "}
//                       Restaurant Type
//                     </div>
//                     <div className="block text-gray-700 text-sm font-bold mb-2 mr-5">
//                       <input
//                         onChange={(e) =>
//                           setFormData({
//                             ...formData,
//                             restaurantType: e.target.value,
//                           })
//                         }
//                         placeholder="Type cafe,dine-in,bar "
//                         className="mt-3 mr-70 shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                       />{" "}
//                     </div>
//                   </div>
//                 </div>

//                 <div className="flex flex-col md:flex-row">
//                   <div className="w-full mx-2 flex-1 svelte-1l8159u">
//                     <div className="font-bold h-6 mt-3 ml-3 text-xs leading-8 uppercase">
//                       Current Rating(Numeric ex : 4.2)
//                     </div>
//                     <div className="block text-gray-700 text-sm font-bold mb-2 mr-5">
//                       <input
//                         onChange={(e) =>
//                           setFormData({
//                             ...formData,
//                             current_rating: e.target.value,
//                           })
//                         }
//                         type="number"
//                         placeholder="enter rating here..."
//                         className="mt-3 mr-70 shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                       />{" "}
//                     </div>
//                   </div>
//                   <div className="w-full mx-2 flex-1 svelte-1l8159u">
//                     <div className="font-bold h-6 mt-3 ml-3 text-xs leading-8 uppercase">
//                       {" "}
//                       Email
//                     </div>
//                     <div className="block text-gray-700 text-sm font-bold mb-2 mr-5">
//                       <input
//                         onChange={(e) =>
//                           setFormData({ ...formData, email: e.target.value })
//                         }
//                         placeholder="jhon@doe.com"
//                         className="mt-3 mr-70 shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                       />{" "}
//                     </div>
//                   </div>

//                   <div className="w-full mx-2 flex-1 svelte-1l8159u">
//                     <div className="font-bold h-6 mt-3 ml-3 text-xs leading-8 uppercase">
//                       {" "}
//                       Password
//                     </div>
//                     <div className="block text-gray-700 text-sm font-bold mb-2 mr-5">
//                       <input
//                         onChange={(e) =>
//                           setFormData({ ...formData, password: e.target.value })
//                         }
//                         placeholder="*******"
//                         className="mt-3 mr-70 shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                       />{" "}
//                     </div>
//                   </div>
//                 </div>

//                 <div className="flex flex-col md:flex-row">
//                   <div className="w-full mx-2 flex-1 svelte-1l8159u">
//                     <div className="font-bold h-6 mt-3 ml-3 text-xs leading-8 uppercase">
//                       Latitude
//                     </div>
//                     <div className="block text-gray-700 text-sm font-bold mb-2 mr-5">
//                       <input
//                         defaultValue={formData.latitude}
//                         onChange={(e) =>
//                           setFormData({ ...formData, latitude: e.target.value })
//                         }
//                         type="number"
//                         placeholder="latitude"
//                         className="mt-3 mr-70 shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                       />{" "}
//                     </div>
//                   </div>
//                   <div className="w-full mx-2 flex-1 svelte-1l8159u">
//                     <div className="font-bold h-6 mt-3 ml-3 text-xs leading-8 uppercase">
//                       Longitude
//                     </div>
//                     <div className="block text-gray-700 text-sm font-bold mb-2 mr-5">
//                       <input
//                         defaultValue={formData.longitude}
//                         onChange={(e) =>
//                           setFormData({
//                             ...formData,
//                             longitude: e.target.value,
//                           })
//                         }
//                         type="number"
//                         placeholder="longitude"
//                         className="mt-3 mr-70 shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                       />{" "}
//                     </div>
//                   </div>
//                 </div>

//                 <div className="flex flex-col md:flex-row">
//                   <div className="w-full mx-2 flex-1 svelte-1l8159u">
//                     <div className="font-bold h-6 mt-3 ml-3 text-xs leading-8 uppercase">
//                       Phone
//                     </div>
//                     <div className="block text-gray-700 text-sm font-bold mb-2 mr-5">
//                       <input
//                         onChange={(e) =>
//                           setFormData({ ...formData, phone: e.target.value })
//                         }
//                         type="phone"
//                         placeholder="enter phone here..."
//                         className="mt-3 mr-70 shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                       />{" "}
//                     </div>
//                   </div>

//                   <div className="w-full mx-2 flex-1 svelte-1l8159u">
//                     <div className="font-bold h-6 mt-3 ml-3 text-xs leading-8 uppercase">
//                       Address
//                     </div>
//                     <div className="block text-gray-700 text-sm font-bold mb-2 mr-5">
//                       <input
//                         onChange={(e) =>
//                           setFormData({ ...formData, address: e.target.value })
//                         }
//                         placeholder="ex : old delhi"
//                         className="mt-3 mr-70 shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                       />{" "}
//                     </div>
//                   </div>
//                 </div>

//                 <div className="flex flex-col md:flex-row">
//                   <div className="w-full mx-2 flex-1 svelte-1l8159u">
//                     <div className="font-bold h-6 mt-3 ml-3 text-xs leading-8 uppercase">
//                       Owner Name
//                     </div>
//                     <div className="block text-gray-700 text-sm font-bold mb-2 mr-5">
//                       <input
//                         onChange={(e) =>
//                           setFormData({
//                             ...formData,
//                             ownerName: e.target.value,
//                           })
//                         }
//                         type="email"
//                         placeholder="Name of Owner"
//                         className="mt-3 mr-70 shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                       />{" "}
//                     </div>
//                   </div>

//                   <div className="w-full mx-2 flex-1 svelte-1l8159u">
//                     <div className="font-bold h-6 mt-3 ml-3 text-xs leading-8 uppercase">
//                       Account Manager
//                     </div>
//                     <div className="block text-gray-700 text-sm font-bold mb-2 mr-5">
//                       <input
//                         onChange={(e) =>
//                           setFormData({
//                             ...formData,
//                             accountManager: e.target.value,
//                           })
//                         }
//                         placeholder="who manages account ?"
//                         className="mt-3 mr-70 shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                       />{" "}
//                     </div>
//                   </div>
//                 </div>

//                 <div className="flex flex-col md:flex-row">
//                   <div className="w-full mx-2 flex-1 svelte-1l8159u">
//                     <div className="font-bold h-6 mt-3 ml-3 text-xs leading-8 uppercase">
//                       Halal Certified ?{" "}
//                     </div>

//                     <div class="flex items-center mt-3 w-full my-12">
//                       {isHalalCertified && (
//                         <div
//                           class="relative"
//                           onClick={() => {
//                             setIsHalalCertified(false);

//                             setFormData({
//                               ...formData,
//                               isHalalCertified: false,
//                             });
//                           }}
//                         >
//                           <input
//                             checked={isHalalCertified}
//                             id="toogleA"
//                             type="checkbox"
//                             class="sr-only"
//                           />
//                           <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
//                           <div class="dot absolute w-6 h-6 bg-green-400 rounded-full shadow left-4 -top-1  transition"></div>
//                         </div>
//                       )}

//                       {!isHalalCertified && (
//                         <div
//                           class="relative"
//                           onClick={() => {
//                             setIsHalalCertified(true);
//                             setFormData({
//                               ...formData,
//                               isHalalCertified: true,
//                             });
//                           }}
//                         >
//                           <input
//                             onChange={() => {}}
//                             checked={isHalalCertified}
//                             id="toogleA"
//                             type="checkbox"
//                             class="sr-only"
//                           />
//                           <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
//                           <div class="dot absolute w-6 h-6 bg-gray-100 rounded-full shadow -left-1 -top-1  transition"></div>
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   <div className="w-full mx-2 flex-1 svelte-1l8159u">
//                     <div className="font-bold h-6 mt-3 ml-3 text-xs leading-8 uppercase">
//                       Halal Certificate{" "}
//                     </div>
//                     <div className="block text-gray-700 text-sm font-bold mb-2 mr-5">
//                       <input
//                         onChange={(e) =>
//                           setFormData({
//                             ...formData,
//                             halalCertificate: e.target.value,
//                           })
//                         }
//                         placeholder="halal certificate number..."
//                         className="mt-3 mr-70 shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                       />{" "}
//                     </div>
//                   </div>

//                   <div className="w-full mx-2 flex-1 svelte-1l8159u">
//                     <div className="font-bold h-6 mt-3 ml-3 text-xs leading-8 uppercase">
//                       Price Range{" "}
//                     </div>
//                     <div className="block text-gray-700 text-sm font-bold mb-2 mr-5">
//                       <input
//                         onChange={(e) =>
//                           setFormData({
//                             ...formData,
//                             priceRange: e.target.value,
//                           })
//                         }
//                         placeholder="Enter Price for one"
//                         type="number"
//                         className="mt-3 mr-70 shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                       />{" "}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       <div className="w-10/12 mx-auto">
//         {stepNumber == 2 && (
//           <RestaurantImages
//             thumbnailImage={thumbnailImage}
//             setThumbnailImage={setThumbnailImage}
//             imagesArray={imagesArray}
//             setImagesArray={setImagesArray}
//           />
//         )}
//       </div>

//       <div className="w-10/12 mx-auto">
//         {stepNumber == 3 && (
//           <CuisinesAndTiming
//             timingArray={timingArray}
//             setTimingArray={setTimingArray}
//             cuisineArray={cuisineArray}
//             setCuisineArray={setCuisineArray}
//           />
//         )}
//       </div>

//       <div className="w-10/12 mx-auto">
//         {stepNumber == 4 && (
//           <div className="my-20 w-full text-center">
//             {!formSubmitted && (
//               <h4 className="text-lg">
//                 Are you Sure you want to submit details ?
//               </h4>
//             )}

//             {loading && (
//               <div className=" flex justify-center items-center">
//                 <div className="animate-spin rounded-full h-20 w-20 border-t-2 border-b-2 border-purple-500" />
//               </div>
//             )}

//             {formSubmitted && (
//               <div>
//                 <div
//                   class="bg-green-500 border-t-4 w-60% mx-auto border-green-500 rounded-b text-white px-4 py-3 shadow-md"
//                   role="alert"
//                 >
//                   <div class="flex">
//                     <div class="py-1">
//                       <svg
//                         class="fill-current h-6 w-6 text-teal-500 mr-4"
//                         xmlns="http://www.w3.org/2000/svg"
//                         viewBox="0 0 20 20"
//                       >
//                         <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
//                       </svg>
//                     </div>
//                     <div>
//                       <p class="font-bold">Restaurant Created Successfully !</p>
//                       <p class="text-sm">
//                         Start Adding Floors and Seating Arrangements !.
//                       </p>
//                     </div>
//                   </div>
//                 </div>

//                 {/* <Link to={`/restaurantfloors/${restaurantId}`}>
//                   {" "}
//                   <button
//                     className="text-base mx-auto mt-10 bg-purple-500 text-white font-medium border hover:scale-110 focus:outline-none flex justify-center px-4 py-2 rounded  cursor-pointer
//                          "
//                   >
//                     Create Seating & Floors
//                   </button>
//                 </Link> */}
//               </div>
//             )}
//           </div>
//         )}
//       </div>

//       {!formSubmitted && (
//         <div className="flex p-8 w-10/12 relative  bottom-10   mx-auto   mt-5">
//           <button
//             name="prev"
//             onClick={(e) => handleStep(e)}
//             className="text-base border hover:scale-110 focus:outline-none flex justify-center px-4 py-2 rounded font-medium cursor-pointer
//                                      "
//           >
//             Previous
//           </button>

//           <div className="flex-auto flex flex-row-reverse">
//             {stepNumber == 4 && (
//               <button
//                 onClick={() => handleSubmit()}
//                 className="text-base mx-3 bg-purple-500 text-white font-medium border hover:scale-110 focus:outline-none flex justify-center px-4 py-2 rounded  cursor-pointer
//                                      "
//               >
//                 Create Restaurant
//               </button>
//             )}

//             {stepNumber < 4 && (
//               <button
//                 disabled
//                 className="text-base mx-3 bg-gray-400 text-white font-medium border hover:scale-110 focus:outline-none flex justify-center px-4 py-2 rounded  cursor-pointer
//                                      "
//               >
//                 Create Restaurant
//               </button>
//             )}

//             <button
//               name="next"
//               onClick={(e) => handleStep(e)}
//               className="text-white text-base border hover:scale-110 bg-green-700 focus:outline-none flex justify-center px-4 py-2 rounded font-medium cursor-pointer"
//             >
//               Next{" "}
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CreateRestro;

import React, { useState } from "react";
import axios from "axios";
import CuisinesAndTiming from "../CreateRestro_Container/components/CuisinesAndTiming";
import FloorsAndTables from "./components/FloorsAndTables";

function CreateRestro() {
  const [activeTab, setActiveTab] = useState(0);
  const [latitude, setLatitude] = useState(0);
  const [longitude, setLongitude] = useState(0);
  const [cuisineNames, setCuisineNames] = useState([]);
  const [restaurantId, setRestaurantId] = useState();
  const [restaurantTimings, setRestaurantTimings] = useState([
    {
      weekDay: "SUNDAY",
      openingTiming: "",
      breakTiming: "",
      closingTiming: "",
    },
    {
      weekDay: "MONDAY",
      openingTiming: "",
      breakTiming: "",
      closingTiming: "",
    },
    {
      weekDay: "TUESDAY",
      openingTiming: "",
      breakTiming: "",
      closingTiming: "",
    },
    {
      weekDay: "WEDNESDAY",
      openingTiming: "",
      breakTiming: "",
      closingTiming: "",
    },
    {
      weekDay: "THURSDAY",
      openingTiming: "",
      breakTiming: "",
      closingTiming: "",
    },
    {
      weekDay: "FRIDAY",
      openingTiming: "",
      breakTiming: "",
      closingTiming: "",
    },
    {
      weekDay: "SATURDAY",
      openingTiming: "",
      breakTiming: "",
      closingTiming: "",
    },
  ]);
  const [formData, setFormData] = useState({
    restaurantName: "",
    restaurantOwner: "",
    restaurantEmail: "",
    restaurantPassword: "",
    restaurantAccountManager: "",
    restaurantRating: 0,
    restaurantAddress: "",
    restaurantType: "",
    restaurantPhone: "",
    restaurantHalalCertificate: "",
    restaurantRegistrationNo: "",
    restaurantWebsite: "",
    restaurantPrice: "",
    restuarantPricePerPerson: 0,
    isPrepaidBookingAvaliable: false,
  });

  async function submitDetails(formData) {
    formData = {
      ...formData,
      cuisineNames,
      restaurantTimings,
      restaurantLocation: { type: "Point", coordinates: [longitude, latitude] },
    };

    console.log(formData);
    await axios
      .post("/restaurant/create-restaurant", formData)
      .then((res) => {
        console.log(res.data);
        setRestaurantId(res.data.restaurantId);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  return (
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <div>
        <p class="font-semibold text-4xl mt-10 text-gray-700">
          Add a Restaurant
        </p>
      </div>
      <div style={{ display: "flex", alignItems: "flex-start" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: "315px",
            textAlign: "left",
            margin: "31px 20px 31px 0px",
            backgroundColor: "white",
            borderRadius: "5px",
            padding: "10px 20px 90px 10px",
          }}
          class="shadow-2xl"
        >
          <button
            style={{
              textAlign: "left",
              width: "200px",
              padding: "7px",
              margin: "10px",
            }}
            class="bg-gray-200  text-gray-500 hover:text-white hover:bg-custom-background"
            onClick={() => {
              setActiveTab(0);
            }}
          >
            Details
          </button>
          <button
            style={{
              textAlign: "left",
              width: "200px",
              padding: "7px",
              margin: "10px",
            }}
            class="bg-gray-200  text-gray-500 hover:text-white hover:bg-custom-background"
            onClick={() => {
              setActiveTab(1);
            }}
          >
            Cuisines and Timing
          </button>
          <button
            style={{
              textAlign: "left",
              width: "200px",
              padding: "7px",
              margin: "10px",
            }}
            class="bg-gray-200  text-gray-500 hover:text-white hover:bg-custom-background"
            onClick={() => {
              setActiveTab(2);
            }}
          >
            Floors and Tables
          </button>
          <button
            style={{
              textAlign: "left",
              width: "200px",
              padding: "7px",
              margin: "10px",
            }}
            class="bg-gray-200  text-gray-500 hover:text-white hover:bg-custom-background"
            onClick={() => {
              setActiveTab(3);
            }}
          >
            Images
          </button>
          <button
            style={{
              textAlign: "left",
              width: "200px",
              padding: "7px",
              margin: "10px",
            }}
            class="bg-gray-200  text-gray-500 hover:text-white hover:bg-custom-background"
            onClick={() => {
              setActiveTab(4);
            }}
          >
            Submit
          </button>
        </div>
        <div
          style={{
            padding: "20px",
            borderRadius: "5px",
            backgroundColor: "white",
            marginTop: "30px",
            marginBottom: "30px",
            width: "900px",
          }}
          class="shadow-2xl"
        >
          <form>
            {activeTab === 0 && (
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "15px 0",
                  }}
                >
                  <div>
                    <label
                      class="ml-3 font-normal text-s text-gray-500"
                      for="usernameField"
                    >
                      Restaurant Name
                    </label>
                    <input
                      class="flex items-center h-10 px-4 w-96 bg-gray-200 mt-2 rounded focus:outline-none focus:ring-2 shadow-md"
                      type="text"
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          restaurantName: e.target.value,
                        });
                      }}
                    />
                  </div>

                  <div>
                    <label
                      class="ml-3 font-normal text-s text-gray-500"
                      for="usernameField"
                    >
                      Restaurant Type
                    </label>
                    <input
                      class="flex items-center h-10 px-4 w-96 bg-gray-200 mt-2 rounded focus:outline-none focus:ring-2 shadow-md"
                      type="text"
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          restaurantType: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "15px 0",
                  }}
                >
                  <div>
                    <label
                      class="ml-3 font-normal text-s text-gray-500"
                      for="usernameField"
                    >
                      Restaurant Owner
                    </label>
                    <input
                      class="flex items-center h-10 px-4 w-64 bg-gray-200 mt-2 rounded focus:outline-none focus:ring-2 shadow-md"
                      type="text"
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          restaurantOwner: e.target.value,
                        });
                      }}
                    />
                  </div>

                  <div>
                    <label
                      class="ml-3 font-normal text-s text-gray-500"
                      for="usernameField"
                    >
                      Restaurant Account Manager
                    </label>
                    <input
                      class="flex items-center h-10 px-4 w-64 bg-gray-200 mt-2 rounded focus:outline-none focus:ring-2 shadow-md"
                      type="email"
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          restaurantAccountManager: e.target.value,
                        });
                      }}
                    />
                  </div>

                  <div>
                    <label
                      class="ml-3 font-normal text-s text-gray-500"
                      for="usernameField"
                    >
                      Restaurant Phone
                    </label>
                    <input
                      class="flex items-center h-10 px-4 w-64 bg-gray-200 mt-2 rounded focus:outline-none focus:ring-2 shadow-md"
                      type="text"
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          restaurantPhone: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "15px 0",
                  }}
                >
                  <div>
                    <label
                      class="ml-3 font-normal text-s text-gray-500"
                      for="usernameField"
                    >
                      Restaurant Email
                    </label>
                    <input
                      class="flex items-center h-10 px-4 w-96 bg-gray-200 mt-2 rounded focus:outline-none focus:ring-2 shadow-md"
                      type="email"
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          restaurantEmail: e.target.value,
                        });
                      }}
                    />
                  </div>

                  <div>
                    <label
                      class="ml-3 font-normal text-s text-gray-500"
                      for="usernameField"
                    >
                      Restaurant Password
                    </label>
                    <input
                      class="flex items-center h-10 px-4 w-96 bg-gray-200 mt-2 rounded focus:outline-none focus:ring-2 shadow-md"
                      type="password"
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          restaurantPassword: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "15px 0",
                  }}
                >
                  <div>
                    <label
                      class="ml-3 font-normal text-s text-gray-500"
                      for="usernameField"
                    >
                      Restaurant Address
                    </label>
                    <input
                      class="flex items-center h-10 px-4 w-64 bg-gray-200 mt-2 rounded focus:outline-none focus:ring-2 shadow-md"
                      type="text"
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          restaurantAddress: e.target.value,
                        });
                      }}
                    />
                  </div>

                  <div>
                    <label
                      class="ml-3 font-normal text-s text-gray-500"
                      for="usernameField"
                    >
                      Restaurant Longitude
                    </label>
                    <input
                      class="flex items-center h-10 px-4 w-64 bg-gray-200 mt-2 rounded focus:outline-none focus:ring-2 shadow-md"
                      type="number"
                      onChange={(e) => {
                        setLongitude(e.target.value);
                      }}
                    />
                  </div>

                  <div>
                    <label
                      class="ml-3 font-normal text-s text-gray-500"
                      for="usernameField"
                    >
                      Restaurant Latitude
                    </label>
                    <input
                      class="flex items-center h-10 px-4 w-64 bg-gray-200 mt-2 rounded focus:outline-none focus:ring-2 shadow-md"
                      type="number"
                      onChange={(e) => {
                        setLatitude(e.target.value);
                      }}
                    />
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "15px 0",
                  }}
                >
                  <div>
                    <label
                      class="ml-3 font-normal text-s text-gray-500"
                      for="usernameField"
                    >
                      Restaurant Website
                    </label>
                    <input
                      class="flex items-center h-10 px-4 w-96 bg-gray-200 mt-2 rounded focus:outline-none focus:ring-2 shadow-md"
                      type="text"
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          restaurantWebsite: e.target.value,
                        });
                      }}
                    />
                  </div>

                  <div>
                    <label
                      class="ml-3 font-normal text-s text-gray-500"
                      for="usernameField"
                    >
                      Restaurant Registration Number
                    </label>
                    <input
                      class="flex items-center h-10 px-4 w-96 bg-gray-200 mt-2 rounded focus:outline-none focus:ring-2 shadow-md"
                      type="email"
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          restaurantRegistrationNo: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "15px 0",
                  }}
                >
                  <div>
                    <label
                      class="ml-3 font-normal text-s text-gray-500"
                      for="usernameField"
                    >
                      Restaurant Ratings
                    </label>
                    <input
                      class="flex items-center h-10 px-4 w-64 bg-gray-200 mt-2 rounded focus:outline-none focus:ring-2"
                      type="number"
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          restaurantRating: e.target.value,
                        });
                      }}
                    />
                  </div>

                  <div>
                    <label
                      class="ml-3 font-normal text-s text-gray-500"
                      for="usernameField"
                    >
                      Restaurant Average Price
                    </label>
                    <input
                      class="flex items-center h-10 px-4 w-64 bg-gray-200 mt-2 rounded focus:outline-none focus:ring-2"
                      type="number"
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          restaurantPrice: e.target.value,
                        });
                      }}
                    />
                  </div>

                  <div>
                    <label
                      class="ml-3 font-normal text-s text-gray-500"
                      for="usernameField"
                    >
                      Halal Certificate Number
                    </label>
                    <input
                      class="flex items-center h-10 px-4 w-64 bg-gray-200 mt-2 rounded focus:outline-none focus:ring-2"
                      type="number"
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          restaurantHalalCertificate: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "15px 0",
                  }}
                >
                  <div>
                    <label
                      class="ml-3 font-normal text-s text-gray-500"
                      for="usernameField"
                    >
                      Is Prepaid Booking Avaliable ?
                    </label>
                    <select
                      class="ml-2 flex items-center h-10 px-4 w-96 bg-gray-200 mt-2 rounded focus:outline-none focus:ring-2"
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          isPrepaidBookingAvaliable: e.target.value,
                        });
                      }}
                    >
                      <option>Yes</option>
                      <option>No</option>
                    </select>
                  </div>

                  <div>
                    <label
                      class="ml-3 font-normal text-s text-gray-500"
                      for="usernameField"
                    >
                      Restaurant Cost/Person
                    </label>
                    <input
                      class="flex items-center h-10 px-4 w-96 bg-gray-200 mt-2 rounded focus:outline-none focus:ring-2"
                      type="number"
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          restuarantPricePerPerson: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
            {activeTab === 1 && (
              <div>
                <CuisinesAndTiming
                  cuisineName={cuisineNames}
                  setCuisineName={setCuisineNames}
                  restaurantTimings={restaurantTimings}
                  setRestaurantTimings={setRestaurantTimings}
                />
              </div>
            )}
            {activeTab === 2 && (
              <div>
                <FloorsAndTables />
              </div>
            )}
            {activeTab === 3 && (
              <div>
                <h2>Images</h2>
              </div>
            )}
            {activeTab === 4 && (
              <div>
                <h2>Submit</h2>
              </div>
            )}
            <div
              style={{
                display: "flex",
                align: "center",
                justifyContent: "space-between",
              }}
            >
              <div>
                {activeTab > 0 && (
                  <button
                    name="next"
                    className="text-white text-base border hover:scale-110 bg-gray-500 focus:outline-none flex justify-center px-4 py-2 rounded font-medium cursor-pointer"
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveTab(activeTab - 1);
                    }}
                  >
                    Previous
                  </button>
                )}
              </div>
              <div>
                {activeTab < 4 && (
                  <button
                    name="next"
                    className="text-white text-base border hover:scale-110 bg-custom-background focus:outline-none flex justify-center px-4 py-2 rounded font-medium cursor-pointer"
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveTab(activeTab + 1);
                      if (activeTab === 1) {
                        submitDetails(formData);
                      }
                    }}
                  >
                    Add{" "}
                  </button>
                )}
                {activeTab === 4 && (
                  <button
                    name="next"
                    className="text-white text-base border hover:scale-110 bg-custom-background focus:outline-none flex justify-center px-4 py-2 rounded font-medium cursor-pointer"
                  >
                    Add Restaurant
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CreateRestro;
